import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row q-gutter-sm" }
const _hoisted_2 = {
  key: 0,
  class: "col-3"
}
const _hoisted_3 = { class: "col-3" }
const _hoisted_4 = { class: "col-12" }

import { ref } from 'vue';

interface Props {
  // 容量表示フラグ
  capacityFlg: boolean;
  // 非活性フラグ
  disable: boolean;
}
interface AllInputComent {
  desiredCapacity: string;
  desiredQuantity: string;
  comment: string;
}

// ダイアログ表示フラグ

export default /*@__PURE__*/_defineComponent({
  __name: 'BatchInputButton',
  props: {
    capacityFlg: { type: Boolean },
    disable: { type: Boolean }
  },
  emits: ["batchInput"],
  setup(__props: any, { emit: __emit }) {



// コメント一括入力 interface
const dialogFlg = ref(false);
// 希望容量
const desiredCapacity = ref('');
// 希望数量
const desiredQuantity = ref('0');
// コメント
const comment = ref('');

// 初期値設定
const init = () => {
  desiredCapacity.value = '';
  desiredQuantity.value = '1';
  comment.value = '';
  dialogFlg.value = true;
};

const emit = __emit;

// 一括入力
const batchInput = () => {
  const inputs = {
    desiredCapacity: desiredCapacity.value,
    desiredQuantity: desiredQuantity.value,
    comment: comment.value,
  };
  dialogFlg.value = false;
  emit('batchInput', inputs);
};

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_q_btn, {
      outline: "",
      color: "primary",
      icon: "mdi-pencil",
      disable: _ctx.disable,
      class: "batch-btn export-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (init()))
    }, {
      default: _withCtx(() => _cache[6] || (_cache[6] = [
        _createTextVNode("一括入力")
      ])),
      _: 1
    }, 8, ["disable"]),
    _createVNode(_component_q_dialog, {
      modelValue: dialogFlg.value,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dialogFlg).value = $event)),
      class: "batchinput-button",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"700px","max-width":"inherit"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, { style: {"padding":"0"} }, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, null, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createElementVNode("span", {
                      class: "text-weight-bold",
                      style: {"font-size":"22px","color":"var(--q-primary)"}
                    }, "一括入力", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  (_ctx.capacityFlg)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _cache[8] || (_cache[8] = _createElementVNode("label", null, " 希望容量 ", -1)),
                        _createVNode(_component_q_input, {
                          modelValue: desiredCapacity.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((desiredCapacity).value = $event)),
                          clearable: "",
                          class: "input-area left-input",
                          outlined: "",
                          dense: "",
                          maxlength: "30"
                        }, null, 8, ["modelValue"])
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_3, [
                    _cache[9] || (_cache[9] = _createElementVNode("label", null, " 数量 ", -1)),
                    _createVNode(_component_q_input, {
                      modelValue: desiredQuantity.value,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((desiredQuantity).value = $event)),
                      outlined: "",
                      dense: "",
                      mask: "##",
                      maxlength: "2",
                      "input-class": "text-right",
                      class: "input-area",
                      style: {"width":"100px"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _cache[10] || (_cache[10] = _createElementVNode("label", null, " コメント ", -1)),
                    _createVNode(_component_q_input, {
                      modelValue: comment.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((comment).value = $event)),
                      clearable: "",
                      outlined: "",
                      dense: "",
                      counter: "",
                      maxlength: "200",
                      type: "textarea",
                      class: "input-area left-input",
                      autogrow: ""
                    }, null, 8, ["modelValue"])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, {
              align: "center",
              class: "text-primary"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  color: "primary",
                  label: "確定",
                  onClick: batchInput
                }),
                _createVNode(_component_q_btn, {
                  label: "キャンセル",
                  outline: "",
                  style: {"color":"var(--q-delete)","margin-left":"12px"},
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (dialogFlg.value = false))
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})